import { client } from '../http';

export default {
  async getPromotion(promoCode) {
    const response = await client.get(`/api/no-auth/promotion/${encodeURIComponent(promoCode)}`);
    return response.data;
  },
  async getPromotionForSource(promoSource) {
    const response = await client.get(`/api/no-auth/promotion/by-source/${encodeURIComponent(promoSource)}`);
    return response.data;
  },
  async isRegisteredUsingHeverPromotion() {
    const response = await client.get('/api/is-registered-using-hever');
    return response.data;
  },
};
